import { Spinner } from '@vkontakte/vkui';
import { withDelay } from '../../../components/DelayedRender/DelayedRender';

export const DelayedSpinner = withDelay(Spinner);
